"use strict";
var globalThis = require("../internals/global-this");
var fails = require("../internals/fails");
var checkCorrectnessOfIteration = require("../internals/check-correctness-of-iteration");
var NATIVE_ARRAY_BUFFER_VIEWS = require("../internals/array-buffer-view-core").NATIVE_ARRAY_BUFFER_VIEWS;
var ArrayBuffer = globalThis.ArrayBuffer;
var Int8Array = globalThis.Int8Array;
module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function() {
  Int8Array(1);
}) || !fails(function() {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function(iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function() {
  return new Int8Array(new ArrayBuffer(2), 1, void 0).length !== 1;
});
